import { defineStore } from "pinia";

interface GlobalState {
    /**
     * 服务端是否禁止访问
     */
    serverForbid: boolean;
};
export const useGlobalStore = defineStore({
    id: 'app-global',
    persist: true,
    state: (): GlobalState => ({
        serverForbid: false,
    }),
    actions: {
        setServerForbid(payload: boolean = false){
            this.serverForbid = payload;
        },
    }
});